import { render } from "./Rolelist.vue?vue&type=template&id=009b1152&scoped=true"
import script from "./Rolelist.vue?vue&type=script&lang=js"
export * from "./Rolelist.vue?vue&type=script&lang=js"

import "./Rolelist.vue?vue&type=style&index=0&id=009b1152&scoped=true&lang=scss"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009b1152"]])

export default __exports__